<app-sidebar></app-sidebar>
<main class="dashboard-main">
  <div class="dashboard-content">
    <div class="dashboard-header" style="display:flex; align-items:center; justify-content:space-between;">
      <div>
        <h1 class="dashboard-title">Staff</h1>
        <div class="dashboard-welcome">Manage your team members and their roles</div>
      </div>
      <button class="add-btn px-4 py-2 md:px-5 md:py-2.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors cursor-pointer font-medium text-sm md:text-base"
        *ngIf="userType === 'admin' || userType === 'super_admin'" (click)="openAddModal()">
        Add Staff
      </button>
    </div>
    <hr>
    <div class="my-6 flex flex-col md:flex-row gap-3">
      <input type="text" placeholder="Search staff..." [(ngModel)]="searchTerm" #searchBox
        (input)="onSearch(searchBox.value)"
        class="flex-1 md:w-80 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500" />
    </div>
    <div class="overflow-x-auto md:overflow-x-visible rounded-lg">
    <table class="modern-table min-w-full">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Status</th>
          <th>Joined</th>
          <th *ngIf="userType === 'admin' || userType === 'super_admin'">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let s of staff">
          <td>{{s.name}}</td>
          <td>{{s.email}}</td>
          <td>{{s.phone_number}}</td>
          <td>
            <span class="status" [class]="getStatusClass(s.is_active)">
              {{s.is_active ? 'Active' : 'Inactive'}}
            </span>
          </td>
          <td>{{s.created_at | date:'mediumDate'}}</td>
          <td *ngIf="userType === 'admin' || userType === 'super_admin'">
            <span class="action-btn" (click)="editStaff(s)" title="Edit">
              <i class="fas fa-edit"></i>
            </span>
            <span class="action-btn delete" (click)="deleteStaff(s)" title="Delete">
              <i class="fas fa-trash"></i>
            </span>
          </td>
        </tr>
        <tr *ngIf="!loading && staff.length === 0">
          <td colspan="6" style="text-align:center; padding:24px; color:#888;">No data</td>
        </tr>
        <tr *ngIf="loading">
          <td colspan="6" style="text-align:center; padding:24px; color:#888;">Loading...</td>
        </tr>
      </tbody>
    </table>
    </div>
    <div *ngIf="pagination.totalPages > 1" class="mt-6 flex flex-col sm:flex-row justify-center items-center gap-3 flex-wrap">
      <button (click)="goToPage(pagination.page - 1)" [disabled]="!pagination.hasPrev"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Prev</button>
      <span class="text-sm text-gray-600">Page {{pagination.page}} of {{pagination.totalPages}}</span>
      <button (click)="goToPage(pagination.page + 1)" [disabled]="!pagination.hasNext"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Next</button>
    </div>

    <app-add-staff-modal *ngIf="showAddModal" [isEdit]="isEditMode" [staffData]="selectedStaffData"
      (close)="closeAddModal()" (submitStaff)="handleAddStaff($event)">
    </app-add-staff-modal>

    <!-- Delete Confirmation -->
    <div *ngIf="showDeleteConfirm" class="confirm-backdrop" (click)="cancelDelete()"></div>
    <div *ngIf="showDeleteConfirm" class="confirm-dialog">
      <div class="confirm-icon">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <h3>Delete Staff Member</h3>
      <p>Are you sure you want to delete <strong>{{deletingStaff?.name}}</strong>? This action cannot be undone.</p>
      <div class="confirm-actions">
        <button class="confirm-btn cancel" (click)="cancelDelete()" [disabled]="deleting">Cancel</button>
        <button class="confirm-btn delete" (click)="confirmDelete()" [disabled]="deleting">
          {{ deleting ? 'Deleting...' : 'Delete' }}
        </button>
      </div>
    </div>

  </div>
</main>